import { useMutation } from "@apollo/client";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
  useToast,
} from "@chakra-ui/react";
import { useContext } from "react";
import { useNavigate } from "react-router";
import { signInWithGoogle, logoutFirebase, auth } from "../firebase";
import { ContextApp } from "../shared/ContextApp";
import { REGISTER_USER } from "./graphql/mutation/User";

export const AuthenticationService = () => {
  const { setUser } = useContext(ContextApp);
  const toast = useToast();
  const [registerUser, { loading, data, error }] = useMutation(REGISTER_USER);
  const navigate = useNavigate();
  const login = async () => {
    const data_user = await signInWithGoogle();
    const token = await data_user?.getIdToken();
    if (data_user) {
      await registerUser({
        variables: {
          input: {
            uid: data_user.uid,
            firstname: data_user.displayName,
            email: data_user.email,
            phone: data_user.phoneNumber,
            token: token,
          },
        },
      })
        .then((dataUser) => {
          window.localStorage.setItem("token", JSON.stringify(token));
          window.localStorage.setItem("user", JSON.stringify(data_user));
          const { data } = dataUser;
          const { registerUser } = data;
          setUser({
            ...data_user,
            role: registerUser.role,
            address: registerUser.address ? registerUser.address : [],
            id: registerUser.id,
          });
          window.location.reload();
        })
        .catch((error) => {
          logout();

          toast({
            duration: 2500,
            position: "top",
            render: () => registerUserError(),
          });
          window.location.reload();
        });
    }
  };

  const registerUserError = () => (
    <>
      <Alert status="error" variant="solid">
        <AlertIcon />
        <Box flex="1">
          <AlertTitle>Ups!</AlertTitle>
          <AlertDescription display="block">
            Se produjo un error loguearse. Por favor intente nuevamente.
          </AlertDescription>
        </Box>
        <CloseButton position="absolute" right="8px" top="8px" />
      </Alert>
    </>
  );

  const logout = () => {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("user");
    setUser(undefined);
    logoutFirebase();
    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      navigate("/");
    }
  };

  return {
    login,
    logout,
  };
};
